import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// SOLA-49 — Modifica dei dati base dell'evento (data, ora, città, venue) con
// notifica email a tutti i partecipanti. Aperto dal pulsante rosso "MODIFICA".
export default function EventBaseEditModal({ event, onClose, onSaved }) {
  const [cities, setCities] = useState([]);
  const [saving, setSaving] = useState(false);

  const participants = (event.participants && Array.isArray(event.participants))
    ? event.participants.filter(p => p.status !== 'cancelled')
    : [];
  const participantCount = participants.length;

  const [form, setForm] = useState({
    location: event.location || '',
    CityId: event.CityId || '',
    date: event.date ? new Date(event.date).toISOString().split('T')[0] : '',
    startTime: event.startTime ? String(event.startTime).slice(0, 5) : '',
    endTime: event.endTime ? String(event.endTime).slice(0, 5) : ''
  });

  useEffect(() => {
    axios.get('/speeddate/api/cities')
      .then(res => setCities(res.data))
      .catch(err => console.error('Error fetching cities', err));
  }, []);

  const submit = async () => {
    const confirm = await window.Swal.fire({
      title: 'Confermi la modifica dei dati base?',
      html: `<div class="mb-3" style="text-align:left;font-size:14px;color:#444;">
              <p>I seguenti campi verranno aggiornati e <strong>${participantCount} partecipante${participantCount === 1 ? '' : 'i'}</strong> riceverà${participantCount === 1 ? '' : 'no'} un'email di notifica:</p>
              <ul style="margin:10px 0 14px 0;line-height:1.6;">
                <li>📅 <strong>Data:</strong> ${form.date || '—'}</li>
                <li>🕐 <strong>Orario:</strong> ${form.startTime || '—'}${form.endTime ? ' - ' + form.endTime : ''}</li>
                <li>📍 <strong>Città:</strong> ${cities.find(c => String(c.id) === String(form.CityId))?.name || '—'}</li>
                <li>🏠 <strong>Venue:</strong> ${form.location || '—'}</li>
              </ul>
              <p style="color:#b91c1c;">⚠️ Per garantire l'equilibrio uomini/donne, chi non potrà essere presente riceverà il link WhatsApp per avvisarci tempestivamente.</p>
            </div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Sì, modifica e invia email',
      cancelButtonText: 'Annulla',
      customClass: { popup: 'swal2-glass' }
    });
    if (!confirm.isConfirmed) return;

    setSaving(true);
    try {
      const payload = {
        location: form.location,
        CityId: form.CityId ? Number(form.CityId) : form.CityId,
        date: form.date,
        startTime: form.startTime,
        endTime: form.endTime,
        confirm: true
      };
      const res = await axios.put(`/speeddate/api/events/${event.id}/base-fields`, payload);
      window.Swal.fire({
        title: 'Evento Modificato!',
        text: `Dati base aggiornati. ${res.data && res.data.sentCount !== undefined ? res.data.sentCount : participantCount} partecipante${participantCount === 1 ? '' : 'i'} notificato${participantCount === 1 ? '' : 'i'} via email.`,
        icon: 'success',
        timer: 3000,
        showConfirmButton: false
      });
      if (onSaved) onSaved();
    } catch (err) {
      const msg = (err.response && err.response.data && err.response.data.error)
        ? err.response.data.error
        : 'Si è verificato un problema durante la modifica.';
      window.Swal.fire('Errore', msg, 'error');
    } finally {
      setSaving(false);
    }
  };

  const inputClass = 'form-control';
  const selectClass = 'form-select';
  const labelClass = 'form-label small fw-bold text-muted';

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060, position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
          <div className="modal-header border-0 pt-4 px-4">
            <h5 className="modal-title fw-bold"><i className="fas fa-calendar-edit text-danger me-2"></i>Modifica Dati Base Evento</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body p-4 pt-2">
            <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '0.85rem' }}>
              <i className="fas fa-exclamation-triangle me-2"></i>
              L'evento ha <strong>{participantCount} partecipante{participantCount === 1 ? '' : 'i'} registrato{participantCount === 1 ? '' : 'i'}</strong>.
              Dopo la conferma, data, ora, città e venue verranno aggiornati e tutti i partecipanti riceveranno un'email di notifica
              con il link WhatsApp diretto per segnalare l'eventuale impossibilità a partecipare (equilibrio uomini/donne).
            </div>

            <div className="mb-3">
              <label className={labelClass}>Locale / Venue</label>
              <input
                type="text"
                className={inputClass}
                placeholder="es. Virtual Bar, Roma"
                required
                value={form.location}
                onChange={e => setForm({ ...form, location: e.target.value })}
              />
            </div>

            <div className="mb-3">
              <label className={labelClass}>Città</label>
              <select
                className={selectClass}
                required
                value={form.CityId}
                onChange={e => setForm({ ...form, CityId: e.target.value })}
              >
                <option value="" disabled>Seleziona Città...</option>
                {cities.map(city => (
                  <option key={city.id} value={city.id} style={{ color: '#000' }}>
                    {city.name} {city.province ? `(${city.province})` : ''}
                  </option>
                ))}
              </select>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className={labelClass}>Data</label>
                <DatePicker
                  selected={form.date ? new Date(form.date + 'T00:00:00') : null}
                  onChange={date => {
                    const y = date.getFullYear();
                    const m = String(date.getMonth() + 1).padStart(2, '0');
                    const d = String(date.getDate()).padStart(2, '0');
                    setForm({ ...form, date: `${y}-${m}-${d}` });
                  }}
                  dateFormat="dd/MM/yyyy"
                  locale="it"
                  className="form-control"
                  required
                  placeholderText="Seleziona data"
                  wrapperClassName="w-100"
                />
              </div>
              <div className="col-md-3">
                <label className={labelClass}>Inizio</label>
                <DatePicker
                  selected={form.startTime ? new Date(`2000-01-01T${form.startTime}:00`) : null}
                  onChange={date => setForm({ ...form, startTime: date ? date.toTimeString().slice(0, 5) : '' })}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Ora"
                  dateFormat="HH:mm"
                  locale="it"
                  className="form-control"
                  placeholderText="HH:MM"
                  wrapperClassName="w-100"
                />
              </div>
              <div className="col-md-3">
                <label className={labelClass}>Fine</label>
                <DatePicker
                  selected={form.endTime ? new Date(`2000-01-01T${form.endTime}:00`) : null}
                  onChange={date => setForm({ ...form, endTime: date ? date.toTimeString().slice(0, 5) : '' })}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Ora"
                  dateFormat="HH:mm"
                  locale="it"
                  className="form-control"
                  placeholderText="HH:MM"
                  wrapperClassName="w-100"
                />
              </div>
            </div>
          </div>
          <div className="modal-footer border-0 px-4 pb-4">
            <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={onClose} disabled={saving}>
              Annulla
            </button>
            <button type="button" className="btn btn-danger rounded-pill px-4 shadow-sm" onClick={submit} disabled={saving}>
              {saving ? 'Invio in corso...' : <><i className="fas fa-paper-plane me-2"></i>Conferma Modifica e Invia Email</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}